+function ($) {
    /* ======= Handle click outside menu ======= */
    $('html').on('click', function(e) {
        //if clicked element is not your element and parents aren't your div
        if (e.target.id != 'navbar' && $(e.target).parents('#navbar').length == 0) {
            $('#extra-menu .collapse').collapse('hide');
        }
    });

    /* ======= Handle collapsing on main page ======= */
    $('.main-page #extra-menu .collapse, .main-page #mobile-nav').on('show.bs.collapse', function () {
        $("#navbar").removeClass('navbar-transparent').addClass('navbar-light');
    });
    $('.main-page #extra-menu .collapse').on('shown.bs.collapse', function () {
        $("#navbar").removeClass('navbar-transparent').addClass('navbar-light');
    });
    $('.main-page #extra-menu .collapse, .main-page #mobile-nav').on('hidden.bs.collapse', function () {
        $("#navbar").removeClass('navbar-light').addClass('navbar-transparent');
    });
}(jQuery);
